import { useI18n } from '@/providers/i18n';

import ContactForm from './components/ContactForm';
import SignalChannels from './components/SignalChannels';
import styles from './ContactPage.module.css';

export default function ContactPage() {
  const { t } = useI18n();

  return (
    <section>
      <header className="page-h">
        <div>
          <span className="nano">/ CONTACT / BOOKING / PRESS</span>
          <h1>{t('label.contact')}</h1>
        </div>
        <span className="meta">RESPONSE WITHIN 72H</span>
      </header>

      <div className={styles.grid}>
        <SignalChannels />
        <div>
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
